import SingletonWebSocket from '../Singletons/SingletonWebSocket'
import { INTEGRATION, INTEGRATION_SUBACTION } from '../../constants';
import { Logger } from '../../js/helpers/Logger';

export const STRATEGIES_SM_TO_INTEGRATION = {
    "chatAdmin": (that, message) => {
        Logger.Trace("[Strategies_SM_To_Integration][chatAdmin] chatAdmin");
        var data = {
            administrator: message.From,
            message: message.Message
        }
        SingletonWebSocket.send(
            SingletonWebSocket.getJson(INTEGRATION.CHAT,
                INTEGRATION_SUBACTION.CHAT_NEW_MESSAGE, data));
    },
};



// WEBPACK FOOTER //
// ./src/js/Strategies/Strategies_SM_To_Integration.js